<template>
  <div class="field-toggle" v-if="isVisible">
      <div class="btn-group btn-group-toggle d-flex" role="group" data-toggle="buttons">

        <label class="btn btn-outline-blue2 w-100 mb-0" :class="{ 'active': getStatus(1) }"
               @click="changeSelectVal(1)"
        >
          <input type="radio" :id="field.form_key + '-yes'" :name="field.form_key" :ref="'field_' + field.form_key"
                 value="1" :tabIndex="question.id" autocomplete="off" v-model="answer"
                 @focus="$emit('questionSelected', question.order)"
          >
          Yes
        </label>
        <label class="btn btn-outline-blue2 w-100 mb-0" :class="{ 'active': getStatus(0) }"
               @click="changeSelectVal(0)"
        >
          <input type="radio" :id="field.form_key + '-no'" :name="field.form_key"
                  value="0" :tabIndex="question.id" autocomplete="off" v-model="answer"
                 @focus="$emit('questionSelected', question.order)"
          >
          No
        </label>
      </div>
  </div>
</template>

<script>

  import elementMixins from '../mixins/elements'

  export default {
  	name: 'LUToggle',
  	mixins: [elementMixins],
  	methods: {
  		changeSelectVal: function (val) {
  			this.answer = val
  		},

		getStatus (expected) {
  			if (this.answer) {
  				return this.answer === expected
			}
			if (this.field.default_answer && this.field.default_answer.length > 0) {
				return (parseInt(this.field.default_answer) === expected)
			}
		}
  	},
	mounted () {
	  if (this.field.default_answer && this.field.default_answer.length > 0) {
		  this.changeSelectVal(parseInt(this.field.default_answer))
		  this.$emit('questionSelected', this.question.order)
	  }
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/elements/Toggle.vue